<template>
    <v-container fluid fill-height pa-0 class="overlay">
        <div class="main-container pa-6">
            <v-flex text-center>
                <v-img
                    :src="require('@/assets/images/error.svg')"
                    class="d-inline-flex mb-8"
                ></v-img>
                <div class="common-text text-center">
                    Что-то пошло не так :(<br>
                    Обновите страницу или перейдите на
                    <a class="error-link" @click="openHome">главную</a>
                </div>
            </v-flex>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'ErrorPage',
    data() {
        return {
            truth: false,
        }
    },
    methods: {
        openHome() {
            this.$router.push({ name: "login" });
        },
    },
}
</script>

<style lang="scss" scoped>
.overlay {
    z-index: 100;
    position: absolute;
    background: #FFFFFF;

    .main-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        a.error-link {
            color: #DA7771;

            &:hover {
                opacity: 0.7;
            }
        }
    }
}
</style>
